import type { Extensions } from "@tiptap/core";
import { Bold, Code, Italic, Link } from "./marks.ts";
import {
  BulletList,
  CodeBlock,
  Doc,
  DocLink,
  Heading,
  KlCallout,
  KlCodeLine,
  KlGroup,
  KlGroupItem,
  KlGroupList,
  KlImage,
  KlKeyValue,
  KlKvPair,
  KlTable,
  KlTableCell,
  KlTableHeaderRow,
  KlTableRow,
  ListItem,
  OrderedList,
  PageBreak,
  Paragraph,
  Placeholder,
  Text,
} from "./nodes.ts";

/** The Klarity block set as headless Tiptap extensions (contract C3). Safe to load in Node. */
export const klarityExtensions: Extensions = [
  Doc,
  Paragraph,
  Text,
  Heading,
  KlTable,
  KlTableHeaderRow,
  KlTableRow,
  KlTableCell,
  KlCodeLine,
  KlGroupList,
  KlGroup,
  KlGroupItem,
  OrderedList,
  BulletList,
  ListItem,
  KlKeyValue,
  KlKvPair,
  KlCallout,
  CodeBlock,
  PageBreak,
  KlImage,
  DocLink,
  Placeholder,
  Bold,
  Italic,
  Code,
  Link,
];
